import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
const rows = [['6 módulos del sistema', '✓', '✓'], ['4 bonos estratégicos', '✓', '✓'], ['Plan de acción 90 días', '✓', '✓'], ['25 Casos de Éxito documentados', '—', '✓'], ['Entrenadores reales por disciplina', '—', '✓'], ['Ver qué hizo alguien como vos', '—', '✓']];
export function ProofSections() {
  return <section className="border-y border-[#d4af37]/18 bg-card px-5 py-20 sm:px-8 sm:py-28" aria-label="Comparación de versiones" data-id="element-130">
      <div className="mx-auto max-w-[700px]" data-id="element-131">
        <Reveal data-id="element-132">
          <SectionHeading centered eyebrow="Comparación de versiones" title="¿Cuál es la diferencia?" data-id="element-133" />
        </Reveal>
        <Reveal className="mt-12 overflow-hidden border border-[#d4af37]/20" data-id="element-134">
          <table className="w-full text-left text-sm" data-id="element-135">
            <thead className="bg-ink font-mono text-[9px] uppercase tracking-[0.12em] text-sage" data-id="element-136">
              <tr data-id="element-137">
                <th className="p-4 font-medium sm:p-5" data-id="element-138">Feature</th>
                <th className="p-4 text-center font-medium sm:p-5" data-id="element-139">Listo</th>
                <th className="border-l border-[#d4af37]/18 bg-[#d4af37]/[0.05] p-4 text-center font-semibold text-gold sm:p-5" data-id="element-140">
                  PRO + Casos
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#d4af37]/18" data-id="element-141">
              {rows.map(([feature, listo, pro]) => <tr key={feature} data-id="element-142">
                  <th className="p-4 font-medium leading-5 text-ivory sm:p-5" data-id="element-143">
                    {feature}
                  </th>
                  <td className="p-4 text-center text-sage sm:p-5" data-id="element-144">{listo}</td>
                  <td className="border-l border-[#d4af37]/18 bg-[#d4af37]/[0.025] p-4 text-center sm:p-5" data-id="element-145">
                    {pro === '✓' ? <CheckIcon className="mx-auto text-gold" size={16} strokeWidth={2.5} aria-label="Incluido" data-id="element-146" /> : <span className="text-sage" data-id="element-147">—</span>}
                  </td>
                </tr>)}
            </tbody>
            <tfoot className="font-mono text-xs" data-id="element-148">
              <tr className="border-t border-[#d4af37]/25" data-id="element-149">
                <td className="p-5 text-sage" data-id="element-150">Pago único</td>
                <td className="p-5 text-center text-sage" data-id="element-151">$19.990</td>
                <td className="border-l border-[#d4af37]/18 p-5 text-center font-bold text-gold" data-id="element-152">
                  $27.990
                </td>
              </tr>
            </tfoot>
          </table>
        </Reveal>
      </div>
    </section>;
}